import * as React from 'react'

function SvgShieldIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M29 19c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12v-6l9-4 9 4v6Zm-9 10c3.75-1 7-5.46 7-9.78V14l-7-3-7 3v5.22c0 4.32 3.25 8.78 7 9.78Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgShieldIcon
